<!--
 * @Author: zl
 * @Date: 2022-07-04 14:58:58
 * @LastEditTime: 2023-01-13 14:37:24
 * @LastEditors: zl
 * @Description: 项目地图 弹窗
-->
<template>
	<el-dialog :title="title"
			   top="4vh"
			   :visible.sync="dialogObj.show"
			   :close-on-press-escape="false"
			   width="1200px"
			   center
			   custom-class="map-dialog"
			   :before-close="dialogBeforeClose">
		<div class="primary-layout">
			<div class="primary-header">
				<div class="left-tabs">
					<el-tabs v-model="dialogObj.activeTab"
							 @tab-click="handleClick"
							 class="left-tab">
						<el-tab-pane label="项目基本信息"
									 name="projectInfo"></el-tab-pane>
						<el-tab-pane label="三方巡查"
									 name="sfInfo"></el-tab-pane>
						<el-tab-pane label="形象进度"
									 name="jdInfo"></el-tab-pane>
						<el-tab-pane label="项目投资"
									 name="investmentInfo"></el-tab-pane>
						<el-tab-pane label="基本资料"
									 name="baseInfo"></el-tab-pane>
					</el-tabs>
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   plain
							   round
							   class="table-btn"
							   @click="enterProject">
						<svg-icon icon-class="form-enter"></svg-icon> 进入项目
					</el-button>
				</div>
			</div>
		</div>
		<div class="custom-height">
			<!-- 项目基本信息 -->
			<template v-if="dialogObj.activeTab == 'projectInfo'">
				<ProjectInfoLook v-if="dialogObj.activeTab == 'projectInfo'"
								 v-loading="projectLoading"
								 ref="ProjectInfoLook"
								 :noRoute="true"></ProjectInfoLook>
			</template>

			<!-- 三方巡查 -->
			<template v-if="dialogObj.activeTab == 'sfInfo'">
				<div class="w-table-layout w-table-page">
					<vxe-table align="center"
							   border
							   :data="projectPatrol"
							   :loading="patrolLoading"
							   height="100%"
							   highlight-hover-row
							   highlight-current-row
							   show-overflow="tooltip"
							   show-header-overflow="tooltip">
						<vxe-column title="申报维度"
									field="dimension"></vxe-column>
						<vxe-column title="标段名称"
									field="packName"></vxe-column>
						<vxe-column title="表单名称"
									field="sname"></vxe-column>
						<vxe-column title="表单类型"
									field="moduleTypeName"></vxe-column>
						<vxe-column title="巡查类型"
									field="patrolTypeName"
									width="120"></vxe-column>
						<vxe-column title="操作人"
									field="updateUserName"
									width="120"></vxe-column>
						<vxe-column title="操作日期"
									field="updateDate"
									width="120">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.updateDate"
											placement="top">
									<span class="vxe-cell--label"
										  v-if="!!row.updateDate">
										{{ row.updateDate.substr(0, 11) }}
									</span>
									<span v-else>-</span>
								</el-tooltip>
							</template>
						</vxe-column>
					</vxe-table>
				</div>
			</template>

			<!-- 形象进度 -->
			<template v-if="dialogObj.activeTab == 'jdInfo'">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table align="center"
								   border
								   :data="projectProgress"
								   :loading="progressLoading"
								   height="100%"
								   highlight-hover-row
								   highlight-current-row
								   show-overflow="tooltip"
								   show-header-overflow="tooltip">
							<vxe-column title="申报维度"
										field="dimension"></vxe-column>
							<vxe-column title="标段名称"
										field="packName"></vxe-column>
							<vxe-column title="节点名称"
										field="sname"></vxe-column>
							<vxe-column title="节点类型"
										field="parentName"></vxe-column>
							<vxe-column title="节点状态"
										field="stateName"
										width="120"></vxe-column>
							<vxe-column title="最后更新人"
										field="updateUserName"
										width="120"></vxe-column>
							<vxe-column title="最后更新日期"
										field="updateDate"
										width="120">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.updateDate"
												placement="top">
										<span class="vxe-cell--label"
											  v-if="!!row.updateDate">
											{{ row.updateDate.substr(0, 11) }}
										</span>
										<span v-else>-</span>
									</el-tooltip>
								</template>
							</vxe-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<vxe-pager :current-page="tableObj.currentPage"
								   :page-size="tableObj.pageSize"
								   :total="tableObj.total"
								   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
								   align="center"
								   @page-change="handleCurrentChange"></vxe-pager>
					</div>
				</div>
			</template>

			<!-- 项目投资 -->
			<template v-if="dialogObj.activeTab == 'investmentInfo'">
				<vxe-table align="center"
						   border
						   :data="projectInvestment"
						   :loading="investmentLoading"
						   highlight-hover-row
						   highlight-current-row
						   show-overflow="tooltip"
						   show-header-overflow="tooltip">
					<vxe-column title="申报维度"
								field="dimension"
								width="100"></vxe-column>
					<vxe-column title="标段名称"
								field="packName"></vxe-column>
					<vxe-column title="累计计划项目总投资(万元)"
								field="totalValue"
								width="220"></vxe-column>
					<vxe-column title="累计完成固定投资(万元)"
								field="outputValue"
								width="200"></vxe-column>
					<vxe-column title="累计完成比例"
								field="outputValueRate">
						<template #default="{ row }">
							<span v-if="row.outputValueRate != '-'">
								{{ row.outputValueRate + '%' }}
							</span>
							<span v-else>{{ row.outputValueRate }}</span>
						</template>
					</vxe-column>
					<vxe-column title="累计付款(万元)"
								field="examineOutputValue"></vxe-column>
					<vxe-column title="累计付款比例"
								field="examineOutputValueRate">
						<template #default="{ row }">
							<span v-if="row.examineOutputValueRate != '-'">
								{{ row.examineOutputValueRate + '%' }}
							</span>
							<span v-else>{{ row.examineOutputValueRate }}</span>
						</template>
					</vxe-column>
				</vxe-table>
			</template>

			<!-- 基本资料 -->
			<template v-if="dialogObj.activeTab == 'baseInfo'">
				<DataView ref="DataView"
						  v-if="dialogObj.activeTab == 'baseInfo'"
						  :currentRow="currentRow"
						  showMode="content"></DataView>
			</template>
		</div>
	</el-dialog>
</template>

<script>
import ProjectInfoLook from '@/views/Common/ProjectInfoLook'
import DataView from '@/views/BasicData/DataView'
import * as API from '@/api/projectMap/projectMapIndex'
import * as ProjectApi from 'api/projectManage/ProjectIndex'
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		projectId: {
			type: String,
			default: '',
		},
	},
	components: { ProjectInfoLook, DataView },
	data() {
		return {
			dialogObj: {
				show: false,
				activeTab: 'projectInfo',
			},
			projectLoading: false, //项目基本信息 loading
			projectPatrol: [], //三方巡查
			patrolLoading: false, //三方巡查 loading
			projectProgress: [], //项目进度
			progressLoading: false, //项目进度 loading
			projectInvestment: [], //项目投资
			investmentLoading: false, //项目投资 loading
			currentRow: {},
			tableObj: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
		}
	},
	created() {},
	mounted() {
		this.currentRow = {
			id: this.projectId,
		}
	},
	methods: {
		// 打开
		open() {
			this.dialogObj.show = true
			this.projectLoading = true
			setTimeout(() => {
				if (this.$refs.ProjectInfoLook) {
					this.$refs.ProjectInfoLook.getInfoData(this.projectId)
				}
			}, 200)
			setTimeout(() => {
				this.projectLoading = false
			}, 600)
		},

		// tab选项卡切换事件
		handleClick({ index }) {
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			switch (index) {
				case '0':
					this.projectLoading = true
					setTimeout(() => {
						if (this.$refs.ProjectInfoLook) {
							this.$refs.ProjectInfoLook.getInfoData(
								this.projectId
							)
						}
					}, 200)
					setTimeout(() => {
						this.projectLoading = false
					}, 600)
					break
				case '1':
					// 三方巡查
					this.getPatrolData()
					break
				case '2':
					// 形象进度
					this.getProgressData()
					break
				case '3':
					// 项目投资
					this.getInvestmentData()
					break
				case '4':
					setTimeout(() => {
						this.$refs.DataView.dialogObj.show = true
					}, 200)
					break
			}
		},

		// 分页change
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.currentPage = currentPage
			this.tableObj.pageSize = pageSize
			this.getProgressData()
		},

		// 弹窗关闭之前
		dialogBeforeClose() {
			this.dialogObj.show = false
			this.$emit('dialogClose', false)
		},

		// 三方巡查
		getPatrolData() {
			this.patrolLoading = true
			API.projectPatrol({
				projectId: this.projectId,
			})
				.then((res) => {
					this.projectPatrol = res.data
					this.patrolLoading = false
				})
				.catch(() => {
					this.patrolLoading = false
				})
		},

		// 形象进度
		getProgressData() {
			this.progressLoading = true
			API.projectProgress({
				projectId: this.projectId,
				current: this.tableObj.currentPage,
				size: this.tableObj.pageSize,
			})
				.then((res) => {
					this.projectProgress = res.data.records
					this.progressLoading = false
					this.tableObj.total = parseInt(res.data.total)
				})
				.catch((err) => {
					this.progressLoading = false
				})
		},

		// 项目投资
		getInvestmentData() {
			this.investmentLoading = true
			API.projectInvestment({
				projectId: this.projectId,
			})
				.then((res) => {
					this.projectInvestment = res.data
					this.investmentLoading = false
				})
				.catch(() => {
					this.investmentLoading = false
				})
		},

		// 进入项目
		enterProject() {
			let url = this.$outUrl
			let token = this.$getSessionItem('token')
			let tenantId = this.$getSessionItem('tenantId')
			let limitId = this.$getSessionItem('limitId')
			ProjectApi.getAuditWorkPower({
				projectId: this.projectId,
			}).then((res) => {
				if (res.operationCode == 1 && res.msg == 'faild') {
					this.$message.warning(res.data)
					return
				}
				window.open(
					`${url}/DxAuditWork/#/main?projectId=${this.projectId}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
					'_blank'
				)
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
.map-dialog {
	z-index: 999999 !important;
	.custom-height {
		height: calc(~'750px - 50px');
	}
}
</style>